import { createI18n } from 'vue-i18n'

import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'en' | 'sl'

// Startbox ships EN as the default UI language (spec §11), SL is available.
const stored = localStorage.getItem('locale')
const initial: AvailableLocales = stored === 'sl' ? 'sl' : 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           initial,
    fallbackLocale:   'en',
    messages:         { en, sl },
    availableLocales: ['en', 'sl'],
})

export default i18n
